@if (hasEmail) {
  <rt-select
    [formControl]="input.control"
    [options]="$any(emailOptions)"
    [hasSearch]="false"
    [includeEmptyOption]="includeEmptyOption"
  >
  </rt-select>
}

@if (!hasEmail) {
  <rt-input variant="rounded" [formControl]="input.control"></rt-input>
}
